export default "__VITE_ASSET__DuqV2ATY__"